/* src/app/external-forgot-password/external-forgot-password.component.css */
body {
  background-color: #f2f2f2;
  color: #ffffff;
}
.forgot_wrapper {
  margin: 55px 0px 55px 0px;
  padding: 0px;
}
.forgot_left {
  text-align: left;
  color: #fff;
}
.forgot_left p {
  font-size: 18px;
  margin-top: 20px;
}
.forgot_left span {
  font-size: 12px;
}
.submitbtn_main {
  padding: 15px 0px 0px 0px;
}
.submitcustom_btn {
  background-color: #fff !important;
  color: #000;
  border-radius: 30px;
  margin-top: 16px;
  text-transform: capitalize;
  box-shadow: none;
}
.cancelbtn_main {
  padding: 43px 0px 0px 0px;
  color: #fff;
  font-size: 12px;
}
.cancelcustom_btn {
  color: #ffffff !important;
}
.input-ErrorField {
  font-size: 12px;
  padding-bottom: 0px;
  margin-bottom: 0px;
  border-bottom-color: #fff !important;
  color: #ea1d25;
  margin-top: 0px;
  background: transparent;
  position: relative;
  background-color: #00cee7;
  padding: 6px;
  display: block;
}
.addMandatory {
  position: relative;
}
.addMandatory::before {
  content: "*";
  font-size: 20px;
  color: #cc0000;
  position: absolute;
  left: -11px;
}
.addMandatory.posAlter {
  clear: both;
}
.addMandatory.posAlter::before {
  top: 16px;
}
.input-field label {
  font-size: 11px;
  padding-left: 5px;
  color: #8bd0f3 !important;
  font-weight: normal;
}
.input-field input {
  padding-bottom: 0px;
  margin-bottom: 0px;
  margin-top: 0px;
  border-bottom-color: #fff !important;
  color: #fff;
  padding-left: 5px;
  height: 36px;
  background: transparent;
  border: none;
  border-bottom: 1px solid #fff;
}
.input-field input {
  padding-left: 0 !important;
}
@media (max-width: 767px) {
  .reg_bg {
    background: #ffffff url(/assets/images/ots_bg.png) no-repeat center top;
    padding-bottom: 40px;
    text-align: center;
    padding-top: 36px;
  }
  .titleV1 {
    margin-top: 20px;
    display: inline-block;
  }
  .newPassword {
    margin-top: 20px;
  }
}
@media (min-width: 768px) and (max-width: 991px) {
  .reg_bg {
    background: #ffffff url(/assets/images/ots_bg.png) no-repeat center top;
    padding-bottom: 40px;
    text-align: center;
    padding-top: 36px;
  }
  .newPassword {
    margin-top: 20px;
  }
  .titleV1 {
    margin-top: 20px;
    display: inline-block;
  }
}
@media (min-width: 992px) and (max-width: 1199px) {
  .reg_bg {
    background: #ffffff url(/assets/images/ots_bg.png) no-repeat center top;
    padding-bottom: 40px;
    text-align: center;
    padding-top: 36px;
  }
}
@media (min-width: 1200px) {
  .reg_bg {
    background: #ffffff url(/assets/images/ots_bg.png) no-repeat center top;
    padding-bottom: 40px;
    text-align: center;
    padding-top: 36px;
  }
}
/*# sourceMappingURL=external-forgot-password.component.css.map */
